export enum Cookies {
    FavoriteStore = 'FavoriteStore',
    WhitelabelUrl = 'whitelabelUrl',
}
